<template>
	<div>
		<curriculos
			:data="myData"
			:loadingtable="isLoading"
			:total-pages="totalPages"
			:currentpage="currentpage"
			@search-text="getFilterData($event)"
			@pagechange="getFilterData($event)"
			@apply-modal="getFilterData($event)"
		/>
	</div>
</template>

<script>
import curriculos from '../../layout/components/table/curriculos';
import * as ecAxios from '../../util/ecAxios';

export default {
	components: {
		curriculos,
	},
	data() {
		return {
			data: [],
			isLoading: true,
			limit: 10,
			offset: 0,
			mytotalPages: 0,
			pagenumber: 0,
			totalPages: 0,
			currentpage: 1,
		};
	},
	computed: {
		myData() {
			return this.data;
		},
	},
	methods: {
		async getFilterData(data, pagenumber = 0) {
			this.isLoading = true;
			this.currentpage = pagenumber;
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.CURRICULOS}/showall`, data)
				.then((response) => {
					if (response.data.error === 0) {
						this.totalPages = response.data.count;
						this.data = response.data.curriculos;
						this.isLoading = false;
					}
				});
		},
	},
};
</script>

<style></style>

